import ResetEmail from "../../components/reset-email/reset-email.component";

export default function ResetEmailPage(){
    return <ResetEmail/>
}